export class PermissionEntry {
    id: number;
    type: string;
    entryId: string;
    scopes: Array<string>;
    userGroupId: number
}